import React from "react";
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaWhatsapp,
} from "react-icons/fa";

const SocialLinks = () => {
  return (
    <div className="bg-white p-5 text-center">
      <h2 className="text-3xl mb-3 font-semibold text-blue-800">
        Share your referral link
      </h2>
      <div className="pt-3">
        <ul>
          <li className="inline-block mx-3 border social-link p-2 rounded-full">
            <a href="https://www.facebook.com/sharer/sharer.php?u=https://artbit.cloud" target="_blank" rel="noopener">
              <FaFacebook className="text-2xl transition-all" />
            </a>
          </li>
          <li className="inline-block mx-3 border social-link p-2 rounded-full">
            <a href="http://www.twitter.com/share?url=https://artbit.cloud" target="_blank">
              <FaTwitter className="text-2xl transition-all" />
            </a>
          </li>
          <li className="inline-block mx-3 border social-link p-2 rounded-full">
            <a href="whatsapp://send?text=https://artbit.cloud" data-action="share/whatsapp/share"
		target="_blank">
              <FaWhatsapp className="text-2xl transition-all" />
            </a>
          </li>
          <li className="inline-block mx-3 border social-link p-2 rounded-full">
            <a href="https://www.linkedin.com/sharing/share-offsite/?url=https://artbit.cloud" target="_blank">
              <FaLinkedinIn className="text-2xl transition-all" />
            </a>
          </li>
          <li></li>
        </ul>
      </div>
      <div><p><span className="text-3xl text-green-500 font-serif ">For any question or help, kindly send us a mail on:
      </span></p><p><span className="text-4xl text-purple-500 font-serif "> 
      artbitlicense@gmail.com
</span></p></div>
    </div>
  );
};

export default SocialLinks;
